//@ts-nocheck

// hasOwn polyfill for old browsers
'hasOwn' in Object || (Object.hasOwn = Object.call.bind(Object.hasOwnProperty));
